// extracted by mini-css-extract-plugin
export default {"col_M":"index_col_M_iUsQc","cattle_stocks":"index_cattle_stocks_VVQio","space16":"index_space16_46o-x","space20":"index_space20_DXQn2"};